import MaskedField from "../../BaseInputFields/MaskedField/MaskedField";
import { EmailProps, FieldLabeledProps } from "../../types/fieldTypes";

export interface EmailFieldProps extends EmailProps {
  labelProps?: FieldLabeledProps;
}

const EmailField: React.FC<EmailFieldProps> = (props) => {
  return (
    <MaskedField
      type={props.type}
      description={props.description}
      label={props.label}
      placeholder={"johnsmith@example.com"}
      fieldName="email"
      value={props.value}
      disabled={props.disabled}
      onSubmit={props.onSubmit}
      errorMessages={props.errorMessages}
      isRequired={props.isRequired}
      labelProps={props.labelProps}
    />
  );
};

export default EmailField;
